import { EmployeeDTO } from 'probonio-shared-ui/api';
import { DuplicateValue } from './duplicates/DuplicateValue';
import { hasDuplicateDisplay } from './employeeDuplicates';
import { LetterAvatar } from './LetterAvatar';

interface Props {
  employee: EmployeeDTO;
  /** Opt-in: only the employee master data list shows the duplicate marker. */
  showDuplicates?: boolean;
}

export const UserNameAndAvatar: React.FC<Props> = ({ employee, showDuplicates }) => {
  return (
    <div data-test-id="user-name-and-avatar" style={{ display: 'flex', alignItems: 'center', maxWidth: 300 }}>
      <LetterAvatar firstName={employee.firstName} lastName={employee.lastName} mail={employee.mail} size={45} />
      <div style={{ marginLeft: 10, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
        <b>
          {employee.lastName}
          {employee.firstName && employee.lastName && ','} {employee.firstName}
        </b>
        {showDuplicates && hasDuplicateDisplay(employee, 'mail') ? (
          <DuplicateValue employee={employee} field="mail" />
        ) : (
          employee.mail && <div>{employee.mail}</div>
        )}
      </div>
    </div>
  );
};
